import React, { useState } from "react";
import { Stack } from "@mui/material";
import {
  AuthTextField,
  Container,
  FrgtPswdLink,
  InputLabel,
  RegisterLabelLink,
  SigninButton,
  Title,
} from "./login.components";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  forgotPasswordLink,
  homepage,
  registerLink,
} from "../../../common/routes";
import { useAlert } from "react-alert";
import { useCookies } from "react-cookie";
import { loginUser } from "../../../services/auth";

function Login() {
  const alert = useAlert();
  const location = useLocation();
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies();
  const [emailID, setEmailID] = useState("");
  const [password, setPassword] = useState("");
  const path = "/";
  const domain = window.location.hostname;

  if (cookies.token !== undefined && cookies.token !== "undefined")
    navigate(homepage);

  const handleLogin = async () => {
    if (validate()) {
      const userData = {
        emailID: emailID,
        password: password,
      };
      await loginUser(userData)
        .then((response) => {
          if (response.status === 401) {
            alert.error(response.data.message);
            return;
          }
          if (response.data) {
            setCookie("emailID", response.data.emailID, { path, domain });
            setCookie("firstName", response.data.firstName, { path, domain });
            setCookie("lastName", response.data.lastName, { path, domain });
            setCookie("userID", response.data.userID, { path, domain });
            setCookie("token", response.data.token, { path, domain });
            alert.success(response.message);
            if (location.state) {
              if (location.state.from) navigate(location.state.from);
            } else navigate(homepage);
          }
        })
        .catch((error) => console.log(error));
    }
  };

  return (
    <Container>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="flex-start"
        spacing={2.5}
        sx={{ py: 5.75, width: 480, m: "auto" }}
      >
        <Title>Sign In</Title>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <InputLabel>Email ID</InputLabel>
          <AuthTextField value={emailID} setValue={setEmailID} type="email" />
        </Stack>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          spacing={2}
        >
          <InputLabel>Password</InputLabel>
          <AuthTextField
            value={password}
            setValue={setPassword}
            type="password"
          />
        </Stack>
        <FrgtPswdLink component={Link} to={forgotPasswordLink}>
          Forgot Password ?
        </FrgtPswdLink>
        <SigninButton onClick={handleLogin}>Sign In</SigninButton>
        <RegisterLabelLink>
          Already have an account ?{" "}
          <RegisterLabelLink
            component={Link}
            to={registerLink}
            linkColor="#1488CC"
          >
            Sign up
          </RegisterLabelLink>
        </RegisterLabelLink>
      </Stack>
    </Container>
  );

  function validate() {
    const emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;

    if (!emailID || !emailRegex.test(emailID)) {
      alert.error("please enter a valid email id");
      return false;
    }
    if (!password) {
      alert.error("please enter the password");
      return false;
    }
    return true;
  }
}

export default Login;
